module.exports = __webpack_public_path__ + "static/media/5N.7bc8cc5f.svg";